<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <!-- {{ this.ferg() }} -->
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">BORRAR USUARIO</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <div class="del_ctn">
                      <p>
                        Está a punto de eliminar el usuario
                        <b>{{ data.email }}</b
                        >, si la acción es correcta digite el correo
                        electrónico, recuerde que esto es irreversible y no
                        podrá recuperar la información.
                      </p>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      ref="email"
                      type="email"
                      v-model="email"
                      :rules="[nameRules.required, nameRules.equal]"
                      label="Correo electrónico"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn
                  class="btn_delete"
                  :disabled="!valid"
                  depressed
                  large
                  @click="validate"
                  >Eliminar</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "UserDelComp",
  components: {},
  props: {
    visible: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      valid: true,
      email: null,
      nameRules: {
        required: (v) => !!v || "El email es requerido",
        equal: (v) =>
          v === this.data.email || "El Correo electrónico no coincide.",
      },
    };
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.$refs.form.reset();
        this.$emit("close");
        // Or any other way you want to close your modal
      }
    });
  },
  methods: {
    ...mapActions(["updateUser", "alertSnackbar"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    async registerForm() {
      try {
        let form = {
          _id: this.data._id,
          state: false,
          acount: 0,
        };
        //function update
        let update = await this.updateUser(form);
        this.$refs.form.reset();
        if (update == 200) {
          this.alertSnackbar({
            snackbar: true,
            text: "El Usuario se ha borrado.",
          });
          this.$root.$emit("reload"); // parametro update tabla
        }
        this.show = false;
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: "ocurrio un error inesperado.",
        });
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset();
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/base.scss";
.del_ctn {
  p {
    font-family: Roboto;
    font-size: 1rem;
    margin-bottom: 0;
  }
}
</style>
